module.exports = __webpack_public_path__ + "img/loading-gray.b585c8ea.svg";